import styled from "styled-components";
import { getHexOpacity } from "../../../../../../../../../utils/pipes";

export const NewBarrierModal = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  .modal-background {
    background-color: ${`#090949${getHexOpacity(0.5)}`};
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 100;
  }
  .modal-container {
    overflow: hidden;
    max-height: 90%;
    z-index: 200;
    background-color: #eeeef7;
    width: 700px;
    margin: auto;
    box-sizing: border-box;
    border-radius: 25px;
    justify-content: end;
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 1200px;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);

    &__reaction {
      width: 100%;
      margin: 200px 0;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;

  .title {
    font-size: 20px;
    color: #707582;
    margin: 0;
    font-family: "Nunito Sans";
  }

  .icon-btn {
    width: 36px;
    height: 36px;
    border-radius: 14px;
    background: #ffffff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
      color: #16158a;
      font-size: 10px;
    }

    &.disable {
      background: transparent;
      box-shadow: none;
      cursor: default;
      color: #16158a;
      font-size: 15px;
    }
  }
`;

export const SelectedPatientSummary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px 25px 30px;
  margin: 0px 20px;
  border-bottom: 1px solid #ffffff;

  .patient-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    .patient-info__icon {
      font-size: 66px;
      color: #707582;
    }

    .patient-info__text {
      font-size: 20px;
      color: #1f1f52;
      font-family: "Nunito Sans Bold";
    }
  }

  img {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    object-fit: cover;
  }

  p {
    margin: 0;
    font-size: 18px;
    color: #1f1f52;

    strong {
      font-weight: 600;
    }
  }

  .subtitle-step2 {
    font-size: 17px;
    color: #707582;
  }

  .subtitle-step3 {
    font-size: 17px;
    color: #707582;

    strong {
      font-family: "Nunito Sans Bold";
    }
  }

  .subtitle-step4 {
    display: flex;
    align-items: center;
    font-size: 17px;
    color: #707582;
    strong {
      font-family: "Nunito Sans Bold";
      margin-left: 5px;
    }

    i {
      font-size: 7px;
      margin-left: 5px;
      vertical-align: middle;
      color: #1f1f52;
    }
  }
`;

export const SearchSection = styled.div`
  display: flex;
  gap: 15px;
  padding: 25px 20px 15px 10px;
  align-items: center;
  /* .program-select {
    
  } */
`;

export const PatientList = styled.div`
  padding: 0 0px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 250px;
  overflow-y: scroll;
  margin-bottom: 20px;
  position: relative;

  /* &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #aab3ea;
    border-radius: 4px;
  } */
`;

export const PatientCard = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 12px 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.02);

  &:hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  }

  .radio-circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #2a28d6;
    display: flex;
    align-items: center;
    justify-content: center;

    .inner-circle {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #1168ff;
    }
  }

  img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;

    .name {
      font-size: 14px;
      color: ${(props) => (props.selected ? "#1168FF" : "#1F1F52")};
      font-weight: 500;
    }

    .email {
      font-size: 12px;
      color: ${(props) => (props.selected ? "#1F1F52" : "#707582")};
      margin-top: 2px;
    }
  }

  .id {
    font-size: 14px;
    color: #707582;
    margin-bottom: auto;
  }
`;

export const BarrierCategoryList = styled.div`
  padding: 0 0px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 250px;
  overflow-y: auto;
  margin-bottom: 20px;
  position: relative;
`;

export const CategoryCard = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.02);

  border: 2px solid ${(props) => (props.selected ? "#3DAEFF" : "transparent")};

  &:hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  }

  h4 {
    margin: 0;
    font-size: 16px;
    color: #404b69;
    font-weight: 500;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: #8c8c8c;
    line-height: 1.4;
  }
`;

export const FormSection = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;

  .textarea-container {
    position: relative;
    border: 1px solid #eaeaea;
    border-radius: 15px;
    padding: 20px;
    background: #ffffff;
    flex: 1;
    display: flex;
    min-height: 180px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.02);

    textarea {
      flex: 1;
      width: 100%;
      border: none;
      outline: none;
      resize: none;
      font-family: inherit;
      font-size: 17px;
      color: #384260;
      &::placeholder {
        color: #a3a3a3;
      }
    }
  }

  .severity-container {
    display: flex;
    flex-direction: column;
    gap: 10px;

    label {
      font-size: 17px;
      color: #3e3e5b;
      margin-left: 20px;
    }

    .severity-selector {
      display: flex;
      border-radius: 20px;
      overflow: hidden;
      background: #f7f7f8;
      border: 1px solid #f7f7f8;
      box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.02);
      padding: 10px;

      &.level-3 {
        border-color: #ff4d4f;
      }
      &.level-2 {
        border-color: #faad14;
      }
      &.level-1 {
        border-color: #52c41a;
      }

      .severity-option {
        padding: 0px 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: #3e3e5b;
        cursor: pointer;
        transition: all 0.3s ease;
        height: 41px;
        border-radius: 20px;
        &.active {
          height: 40px;
          border-radius: 20px;
          color: #ffffff;
          flex: 1;
        }

        &:not(.active):hover {
          background: #f4f5fb;
        }
      }

      &.level-3 .active {
        background: #ff4d4f;
      }
      &.level-2 .active {
        background: #faad14;
      }
      &.level-1 .active {
        background: #52c41a;
      }
    }
  }
`;

export const Footer = styled.div`
  background: #eeeef7;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px -4px 15px rgba(0, 0, 0, 0.01);
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  border-top: 2px solid var(--PRIMITIVES-white_i, #ffffff);
  .btn-back {
  }

  .btn-next {
    background: #2d39c4;
    color: #ffffff;
    border: none;
    border-radius: 20px;
    padding: 12px 35px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    box-shadow: 0px 4px 10px rgba(45, 57, 196, 0.2);
    transition: background 0.2s;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
      background: #252fa1;
    }

    &.finish {
      background: #00a300;
      &:hover {
        background: #008700;
      }
    }

    &.disabled {
      background: #d9ddeb;
      color: #616f8c;
      cursor: not-allowed;
      box-shadow: none;

      &:hover {
        background: #d9ddeb;
      }

      i {
        font-style: normal;
        font-size: 12px;
      }
    }
  }
`;

export const ProgramSelector = styled.div`
  width: 297px;
  height: 225px;
  padding: 10px 10px 0px 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 12px 0px #23229d33;
  background-color: #fff;
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
    &__label {
      color: #707582;
    }
  }
  .list-programs {
    height: calc(100% - 29px);
    overflow: auto;
    .program-item {
      background-color: #f6f6ff;
      padding: 10px;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      margin-bottom: 10px;
      &--actived {
        background-color: #c6c5ff;
        font-family: Nunito Sans Bold;
      }
      &__name {
        font-size: 14px;
        color: #36369b;
      }
      &__quantity {
        display: flex;
        padding: 0px 10px;
        border-radius: 20px;
        background-color: #8a8ac3;
        align-items: center;
      }
      &__icon {
        font-size: 12px;
        color: #f6f6ff;
        margin-right: 5px;
      }
      &__number {
        font-size: 14px;
        color: #f6f6ff;
      }
    }
  }
`;
